module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-03.b5169c1b.png";